// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
var RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

var Types = {};

function unwrap_response_deleteForSaleProperty(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["ForSalePropertyDeleted"]);
}

var variablesConverter = {"deleteForSalePropertyInput":{},"__root":{"input":{"r":"deleteForSalePropertyInput"}}};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

var wrapResponseConverter = {"__root":{"deleteForSaleProperty":{"u":"response_deleteForSaleProperty"}}};

var wrapResponseConverterMap = {
  response_deleteForSaleProperty: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

var responseConverter = {"__root":{"deleteForSaleProperty":{"u":"response_deleteForSaleProperty"}}};

var responseConverterMap = {
  response_deleteForSaleProperty: unwrap_response_deleteForSaleProperty
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

var Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

var Utils = {};

var node = ((function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sellerNodeId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "MyClientsWidgetDeleteDialog_mutations_deleteForSalePropertyMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "deleteForSaleProperty",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/)
            ],
            "type": "ForSalePropertyDeleted",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "MyClientsWidgetDeleteDialog_mutations_deleteForSalePropertyMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "deleteForSaleProperty",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteEdge",
                "key": "",
                "kind": "ScalarHandle",
                "name": "sellerNodeId",
                "handleArgs": [
                  {
                    "kind": "Variable",
                    "name": "connections",
                    "variableName": "connections"
                  }
                ]
              }
            ],
            "type": "ForSalePropertyDeleted",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "27bd2f6c9d5577a4c0e50a8a6274b3a2",
    "id": null,
    "metadata": {},
    "name": "MyClientsWidgetDeleteDialog_mutations_deleteForSalePropertyMutation",
    "operationKind": "mutation",
    "text": "mutation MyClientsWidgetDeleteDialog_mutations_deleteForSalePropertyMutation(\n  $input: DeleteForSalePropertyInput!\n) {\n  deleteForSaleProperty(input: $input) {\n    __typename\n    ... on ForSalePropertyDeleted {\n      sellerNodeId\n    }\n  }\n}\n"
  }
};
})());

var wrap_response_deleteForSaleProperty = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_deleteForSaleProperty = unwrap_response_deleteForSaleProperty;
exports.wrap_response_deleteForSaleProperty = wrap_response_deleteForSaleProperty;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
